import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {TombOfAkhenatenParsedGameData} from "../../server/data/TombOfAkhenatenParsedGameData";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {TombOfAkhenatenGameModuleConfig} from "../../TombOfAkhenatenGameModuleConfig";
import {TombOfAkhenatenGameConfig} from "../../TombOfAkhenatenGameConfig";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TombOfAkhenatenTextStyles} from "../../config/TombOfAkhenatenTextStyles";


export class BetWayWinInitial implements GameRoundPresentation {

    private _gameData:TombOfAkhenatenParsedGameData;
    private _centerReel:number = 12;
    private _isFirstTime: boolean = true;
    private _firstTimeDelay: number = 1.25;
    private _hasWin: boolean = false;
    private _stopIndividualWinForAS:boolean=false;
    private layer:ScalableLayer;
    private isAborted:boolean = false;

    private activatedSprites:PIXI.Sprite [] = [];
    private tl:Timeline;

    constructor() {
        /*EventHandler.addEventListener(this, "stopIndividualWinForAS", (event: GameEvent) => {
            this._stopIndividualWinForAS=event.params[0];
            if(event.params[0]){
                this.cleanup();
            }
        });*/

        this.layer = StageManager.getLayer(TombOfAkhenatenGameConfig.instance.LAYERS.REEL_FOREGROUND.name);
    }
    public prepare(data:ParsedServerData):void {
        this._gameData = <TombOfAkhenatenParsedGameData>data;
        this._hasWin = this._gameData.singleWin > 0 && !this._stopIndividualWinForAS;
    }

    public getAnimation():TimelineLite | null {
        if (!this._hasWin) {
            this.cleanup();
            return null;
        }

        const tl: TimelineLite = new TimelineLite();
        this.isAborted = false;

        /*if(this._isFirstTime){
            tl.add(TweenLite.to(() => {}, this._firstTimeDelay, {}));
            this._isFirstTime = false;
        }*/

        tl.add([
            this.getWinSymbolAnimations(),
        ]);

        this.tl = tl;
        return tl;
    }

    private yPositions: number [] = [];
    private getWinSymbolAnimations():TimelineLite | null {
        let _this = this;
        const tl:TimelineLite = new TimelineLite();

        let dataLength:number = _this._gameData.betWins.length;
        this.yPositions = [];


        for (let i: number = 0; i < dataLength; i++) {
            tl.add([
                this.getBetwayInitialAnimation((_this._gameData.betWins[i] as IBetWayWinData))
            ], 0);
        }

        return tl;
    }

    public getBetwayInitialAnimation(data: IBetWayWinData): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        let winText:PIXI.Text;
        let waysText:PIXI.Text;
        let winTextShadow: PIXI.Sprite;

        winTextShadow = new PIXI.Sprite(GameResources.getTextures("winAmountShadow")[0]);
        winTextShadow.name="winTextShadow";
        winTextShadow.visible = false;
        winTextShadow.anchor.set(0.5);
        winTextShadow.scale.set(0.22, 0.37);

        winText = new PIXI.Text("", TombOfAkhenatenTextStyles.TOA_TEXT_FONT);
        winText.name="winText";
        winText.visible = false;
        winText.anchor.set(0.5);
        winText.scale.set(0.45);

        waysText = new PIXI.Text("", TombOfAkhenatenTextStyles.TOA_TEXT_FONT);
        waysText.name="waysText";
        waysText.visible = false;
        waysText.anchor.set(0.5);
        waysText.scale.set(0.2);

        //this.layer.addChildAt(waysText, 0);
        //this.layer.addChildAt(winText, 0);
        //this.layer.addChildAt(winTextShadow, 0);
        this.layer.addChild(winTextShadow, winText, waysText);
        this.activatedSprites.push(winTextShadow, winText, waysText);


        let _this = this,
            amountText: number = data.multipliedAmount,
            waysWon: number = data.numberOfCombinations,
            firstReels: number[] = [0, 5, 10, 15, 20],
            winningHasFirstReel: number[] = [],
            winTextPosFirst: number[] = [];

        let gameRoundReelWinnigPositions:boolean[] = [];
        for(let i:number = 0; i < _this._gameData.betWins.length; i++) {
            let evaluatedReelWinPositions:boolean[] = (_this._gameData.betWins[i] as IBetWayWinData).reelWinPositions.reduce((acc, currEl) => acc.concat(<any>currEl), []);
            for(let j:number = 0; j < evaluatedReelWinPositions.length; j++) {
                if(!gameRoundReelWinnigPositions[j]) {
                    gameRoundReelWinnigPositions[j] = evaluatedReelWinPositions[j];
                }
            }
        }

        let yIndexForOff: number = -1;
        data.reelWinPositions[0].forEach((bool, sId) => {
            if(bool) {
                yIndexForOff = sId;
                this.yPositions.push(sId);
            }
        });
        const countOccurrences = (arr:number [], val:number) =>
            arr.reduce((a, v) => (v === val ? a + 1 : a), 0);
        const occurences:number =  countOccurrences(this.yPositions, yIndexForOff);

        let yPosStart:number = 0;
        let yPosStartWays:number = 0;

        let firstIndex:number = 0;
        let yIndex: number = -1;
        data.reelWinPositions[0].forEach((bool, sId) => {
            if(bool) {
                firstIndex = winningHasFirstReel[sId];
                yIndex = sId;
                this.yPositions.push(sId);
            }
        });

        winTextPosFirst = Helper.getSymbolPositionsOnReelArea(yIndex, 0);
        yPosStart = (winTextPosFirst[1] + ((TombOfAkhenatenGameConfig.instance.REEL_AREA_HEIGHT / TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN) / 2));
        yPosStartWays = yPosStart + 22;


        tl.add(() => {

            let evaluatedReelWinPositions:boolean[] = data.reelWinPositions.reduce((acc, currEl) => acc.concat(<any>currEl), []);

            /*let firstIndex:number = 0;
            let yIndex: number = -1;
            data.reelWinPositions[0].forEach((bool, sId) => {
                if(bool) {
                    firstIndex = winningHasFirstReel[sId];
                    yIndex = sId;
                    this.yPositions.push(sId);
                }
            });*/

            for(let j:number = 0; j < evaluatedReelWinPositions.length; j++) {
                if(evaluatedReelWinPositions[j]) {
                    if(firstReels.indexOf(j) > -1) {
                        winningHasFirstReel.push(j);
                    }
                    TombOfAkhenatenGameModuleConfig.symbolStateHandler.changeStateOfSymbols(j, 0, TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.win!);
                }else{
                    //#116 semiDimmed other winning symbols
                    if(gameRoundReelWinnigPositions[j]){
                        TombOfAkhenatenGameModuleConfig.symbolStateHandler.changeStateOfSymbols(j, 0, TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.semiDimmed!);
                    }
                }
            }


            // TODO: Figure out a reel on column 1: closestReelForWinText
            /*winTextPosFirst = Helper.getSymbolPositionsOnReelArea(yIndex, 0);
            yPosStart = (winTextPosFirst[1] + ((TombOfAkhenatenGameConfig.instance.REEL_AREA_HEIGHT / TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN) / 2));
            yPosStartWays = yPosStart + 35;*/

            winText.text = amountText.toFixed(2);
            winText.position.set(firstIndex, yPosStart);
            winText.visible = true;
            winText.alpha = 0;

            if (waysWon === 1){
                waysText.text = Translation.translate(waysWon.toString() + " way");
            } else {
                waysText.text = Translation.translate(waysWon.toString() + " ways");
            }
            waysText.position.set(firstIndex, yPosStartWays);
            waysText.visible = true;
            waysText.alpha = 0;

            winTextShadow.position.set(firstIndex, yPosStart);
            winTextShadow.visible = true;
            winTextShadow.alpha = 0;
        });

        // TweenLite.fromTo(winText, 0.3, {x: xOffset},{x: 70 + (xOffset + 20)}),
        tl.add([
            TweenLite.to(winText, 0.2, {alpha:1}),
            TweenLite.to(waysText, 0.2, {alpha:1}),
            TweenLite.to(winTextShadow, 0.2, {alpha:1}),
            // move
            TweenLite.fromTo(winText, 0.4 - (occurences * 0.1), {x: 60},{x: 60}),
            TweenLite.fromTo(waysText, 0.4 - (occurences * 0.1), {x: 60},{x: 60}),
            TweenLite.fromTo(winTextShadow, 0.4 - (occurences * 0.1), {x: 60},{x: 60}),

            TweenLite.fromTo(winText, 0.4 - (occurences * -0.25), {y: yPosStart + (occurences * 15)}, {y: yPosStart - 60 + (occurences * -25)}),
            TweenLite.fromTo(waysText, 0.4 - (occurences * -0.25), {y: yPosStartWays + (occurences * 15)},{y: yPosStartWays - 60 + (occurences * -25)}),
            TweenLite.fromTo(winTextShadow, 0.4 - (occurences * -0.25), {y: yPosStart + (occurences * 15)}, {y: yPosStart - 60 + (occurences * -25)})
        ],"+=0.20"); // 0.20 + (occurences * 0.25)



        tl.add([
            // Fade
            TweenLite.to(winText, 0.8, {alpha:0}),
            TweenLite.to(waysText, 0.8, {alpha:0}),
            TweenLite.to(winTextShadow, 0.8, {alpha:0})
        ]);

        // need to add this empty tween so that the symbol set back to its normal state between the toggling.
        tl.add(() => {
            if(!this.isAborted) {
                this.cleanup();
            }
            //blank tween
        });

        return tl;
    }


    // TODO: Not going to work, make a new presentation for initial betWayWin
    public getBetwayInitialAnimationOld(data: IBetWayWinData): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        let winText:PIXI.Text;
        let waysText:PIXI.Text;
        let winTextShadow: PIXI.Sprite;

        winTextShadow = new PIXI.Sprite(GameResources.getTextures("winAmountShadow")[0]);
        winTextShadow.name="winTextShadow";
        winTextShadow.visible = false;
        winTextShadow.anchor.set(0.5);
        winTextShadow.scale.set(0.45, 0.75);

        winText = new PIXI.Text("", TombOfAkhenatenTextStyles.TOA_TEXT_FONT);
        winText.name="winText";
        winText.visible = false;
        winText.anchor.set(0.5);
        winText.scale.set(0.9);

        waysText = new PIXI.Text("", TombOfAkhenatenTextStyles.TOA_TEXT_FONT);
        waysText.name="waysText";
        waysText.visible = false;
        waysText.anchor.set(0.5);
        waysText.scale.set(0.4);

        this.layer.addChild(winTextShadow, winText, waysText);
        this.activatedSprites.push(winTextShadow, winText, waysText);




        let _this = this,
            amountText: number = data.multipliedAmount,
            waysWon: number = data.numberOfCombinations,
            firstReels: number[] = [0, 5, 10, 15, 20],
            winningHasFirstReel: number[] = [],
            winTextPosFirst: number[] = [];

        let gameRoundReelWinnigPositions:boolean[] = [];
        for(let i:number = 0; i < _this._gameData.betWins.length; i++) {
            let evaluatedReelWinPositions:boolean[] = (_this._gameData.betWins[i] as IBetWayWinData).reelWinPositions.reduce((acc, currEl) => acc.concat(<any>currEl), []);
            for(let j:number = 0; j < evaluatedReelWinPositions.length; j++) {
                if(!gameRoundReelWinnigPositions[j]) {
                    gameRoundReelWinnigPositions[j] = evaluatedReelWinPositions[j];
                }
            }
        }

        let xOffset:number = 0;
        let yOffSetStart:number = 0;
        let yIndexForOff: number = -1;
        data.reelWinPositions[0].forEach((bool, sId) => {
            if(bool) {
                yIndexForOff = sId;
                this.yPositions.push(sId);
            }
        });
        const countOccurrences = (arr:number [], val:number) =>
            arr.reduce((a, v) => (v === val ? a + 1 : a), 0);
        const occurences:number =  countOccurrences(this.yPositions, yIndexForOff);
        yOffSetStart = occurences * (winText.height/2) ;
        xOffset = occurences * winText.width;

        tl.add(() => {

            let evaluatedReelWinPositions:boolean[] = data.reelWinPositions.reduce((acc, currEl) => acc.concat(<any>currEl), []);

            let firstIndex:number = 0;
            let yIndex: number = -1;
            data.reelWinPositions[0].forEach((bool, sId) => {
                if(bool) {
                    firstIndex = winningHasFirstReel[sId];
                    yIndex = sId;
                    this.yPositions.push(sId);
                }
            });

            for(let j:number = 0; j < evaluatedReelWinPositions.length; j++) {
                if(evaluatedReelWinPositions[j]) {
                    if(firstReels.indexOf(j) > -1) {
                        winningHasFirstReel.push(j);
                    }
                    TombOfAkhenatenGameModuleConfig.symbolStateHandler.changeStateOfSymbols(j, 0, TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.win!);
                }else{
                    //#116 semiDimmed other winning symbols
                    if(gameRoundReelWinnigPositions[j]){
                        TombOfAkhenatenGameModuleConfig.symbolStateHandler.changeStateOfSymbols(j, 0, TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.semiDimmed!);
                    }
                }
            }


            // TODO: Figure out a reel on column 1: closestReelForWinText
            winTextPosFirst = Helper.getSymbolPositionsOnReelArea(yIndex, 0);


            winText.text = amountText.toFixed(2);
            winText.position.set(firstIndex, (winTextPosFirst[1] + ((TombOfAkhenatenGameConfig.instance.REEL_AREA_HEIGHT / TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN) / 2) - 20));
            winText.visible = true;
            winText.alpha = 0;

            if (waysWon === 1){
                waysText.text = Translation.translate(waysWon.toString() + " way");
            } else {
                waysText.text = Translation.translate(waysWon.toString() + " ways");
            }
            waysText.position.set(firstIndex, (winTextPosFirst[1] + ((TombOfAkhenatenGameConfig.instance.REEL_AREA_HEIGHT / TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN) / 2) + 20));
            waysText.visible = true;
            waysText.alpha = 0;

            winTextShadow.position.set(firstIndex, (winTextPosFirst[1] + ((TombOfAkhenatenGameConfig.instance.REEL_AREA_HEIGHT / TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN) / 2)));
            winTextShadow.visible = true;
            winTextShadow.alpha = 0;
        });

        // TweenLite.fromTo(winText, 0.3, {x: xOffset},{x: 70 + (xOffset + 20)}),
        tl.add([
            TweenLite.to(winText, 0.2, {alpha:1}),
            TweenLite.to(waysText, 0.2, {alpha:1}),
            TweenLite.to(winTextShadow, 0.2, {alpha:1}),
            // move
            TweenLite.fromTo(winText, 0.3 - (occurences * 0.1), {x: 0},{x: 70 + (occurences * 60)}),
            TweenLite.fromTo(waysText, 0.3 - (occurences * 0.1), {x: 0},{x: 70 + (occurences * 60)}),
            TweenLite.fromTo(winTextShadow, 0.3 - (occurences * 0.1), {x: 0},{x: 70 + (occurences * 60)}),
        ],0.20 + (occurences * 0.35));



        tl.add([
            // Fade
            TweenLite.to(winText, 0.8, {alpha:0}),
            TweenLite.to(waysText, 0.8, {alpha:0}),
            TweenLite.to(winTextShadow, 0.8, {alpha:0})
        ]);

        // need to add this empty tween so that the symbol set back to its normal state between the toggling.
        tl.add(() => {
            if(!this.isAborted) {
                this.cleanup();
            }
            //blank tween
        });

        return tl;
    }


    private cleanup(): void {

        this.activatedSprites.forEach((sprite) => {
            sprite.visible = false;
            this.layer.removeChild(sprite);
        });
        //this.layer.removeChildren();
        this.activatedSprites = [];
        this.yPositions = [];
    }

    public abort(isActive:boolean, data:TombOfAkhenatenParsedGameData):TimelineLite | null {
        let _this = this;
        this._isFirstTime = true;
        const tl:TimelineLite = new TimelineLite();
        this.isAborted = true;
        this.tl.progress(1);

        let totalWinWaysWon: number = 0,
            winAmount: number = 0;

        for (let i: number = 0; i < data.betWins.length; i++) {
            const betWayWinData: IBetWayWinData = <IBetWayWinData>data.betWins[i];
            totalWinWaysWon = totalWinWaysWon + betWayWinData.numberOfCombinations;
            winAmount = winAmount + betWayWinData.amount;
        }

        /*tl.add(() => {
            for(let i:number = 0; i < _this._gameData.betWins.length; i++) {
                let evaluatedReelWinPositions:boolean[] = (_this._gameData.betWins[i] as IBetWayWinData).reelWinPositions.reduce((acc, currEl) => acc.concat(<any>currEl), []);
                for(let j:number = 0; j < evaluatedReelWinPositions.length; j++) {
                    TombOfAkhenatenGameModuleConfig.symbolStateHandler.changeStateOfSymbols(j, 0, TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.normal!);
                }
            }
        }, 0);*/
        //if(isActive) {
            tl.add(() => {
                this.activatedSprites.forEach((sprite) => {
                    sprite.visible = true;
                    sprite.alpha = 1;
                });
            });
            tl.add(() => this.cleanup(), 0.5);

            if(!TombOfAkhenatenGameModuleConfig.featurePrice.isWinBelowStake() && !data.isBigWin) {
                tl.add(() => {
                    const mp: number = data.payoutMultiplier;
                    TombOfAkhenatenGameModuleConfig.toaWinCountUp.getEndingAnimation(data.singleWin, true, totalWinWaysWon, mp, data);
                });
            }
        //}

        return tl;
    }

}